import env from "../utils/env.js";
import axios from "axios";

let headers = {
  Accept: "application/json",
  "Content-Type": "application/json"
};

// NOTE: token is read once at module load. If a new user registers and is
// navigated here via client-side routing (no page reload), this will be
// empty and requests will return 401. Fix: use a request interceptor to
// read sessionStorage.apitoken dynamically on every request.
if (sessionStorage.apitoken) {
  headers["Authorization"] = "Token " + sessionStorage.apitoken;
}

const apiClient = axios.create({
  baseURL: env.serverAddr,
  // withCredentials: true,
  headers: headers
});

// Force a logout on a dead auth token (see shield/user/tasks.py expire_stale_auth_tokens
// and amelia/src/utils/apiClient.js for the full rationale) instead of 401ing forever.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data &&
      error.response.data.status === 401
    ) {
      sessionStorage.removeItem("apitoken");
      localStorage.removeItem("apitoken");
      localStorage.removeItem("token");
      var params = window.location.search;
      window.location = "/login/?r=" + window.location.pathname + (params ? ("&" + params.slice(1)) : "") + window.location.hash;
    }
    return Promise.reject(error);
  }
);

export default apiClient;